"use client";

import dynamic from "next/dynamic";
import { useEffect, useRef, useState } from "react";

// Same size as the MUI Skeleton used before, without pulling MUI/emotion in per card
const PLACEHOLDER_CLASS = "w-1/2 h-[30px] rounded bg-black/10 animate-pulse";
const Loading = () => <div className={PLACEHOLDER_CLASS} />;

const BaseContactInfo = dynamic(() => import("./ContactInfo"), {
  ssr: false,
  loading: Loading,
});

// Cards on listing pages each have call/WhatsApp/schedule buttons (MUI tooltips and
// icons). Mount them only when the card comes near the viewport instead of for every
// card on page load.
export default function ContactInfo({
  hideContactInfo: _hideContactInfo = false,
  queryInput: _queryInput = "",
  ...props
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible || !ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) setVisible(true);
      },
      { rootMargin: "200px" }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [visible]);

  if (visible) return <BaseContactInfo {...props} />;

  return <div ref={ref} className={PLACEHOLDER_CLASS} />;
}
